import * as angular from 'angular';
import { ApplicationRef, DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GoModulesModule } from '@go-modules/go-modules.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { AppDataService } from '@go-modules/services/app-data/app-data.service';
import { AccountEditorModule } from '@lti/app/components/account-editor';
import { UserSessionExpirationModule } from '@lti/app/components/user-session-expiration';
import { AppErrorModule } from '@lti/app/app-error/app-error.module';
import { IframeBannerModule } from '@lti/app/components/iframe-banner';
import { setAngularJSGlobal, UpgradeModule } from '@angular/upgrade/static';
import { TranslateModule } from '@ngx-translate/core';
import {
	provideHttpClient,
	withInterceptorsFromDi
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxFoldersViewModule } from '@dashboard/app/components/folders-view/folders-view.module';
import { ActivityTaskSessionsModule } from '@go-modules/components/activity-task-sessions/activity-task-sessions.module';
import { ltiLegacyModule } from './legacy/lti-legacy.module';
import { injectAppData } from './fetch-app-data';
import { WizardViewModule } from './wizards/wizard-view/wizard-view.module';
import { QuickStartGuideModule } from './wizards/quick-start-guide/quick-start-guide.module';
import {
	MatDialogConfig,
	MAT_DIALOG_DEFAULT_OPTIONS
} from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
	GoLocalizeHelperService,
	Language
} from 'go-modules/translation-helper/go-localize-helper.service';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '@lti/environments/environment';
import { LtiRootViewComponent } from './components/lti-root-view/lti-root-view.component';

@NgModule({
	declarations: [AppComponent],
	imports: [
		GoModulesModule,
		GoMaterialModule,
		BrowserModule,
		BrowserAnimationsModule,
		UpgradeModule,
		TranslateModule.forRoot({
			fallbackLang: 'en',
			loader: provideTranslateHttpLoader({
				prefix: `${environment.translationsPrefix}translations/translation/`
			})
		}),
		AppRoutingModule,
		AccountEditorModule,
		UserSessionExpirationModule,
		AppErrorModule,
		IframeBannerModule,
		NgxFoldersViewModule,
		ActivityTaskSessionsModule,
		WizardViewModule,
		LtiRootViewComponent,
		QuickStartGuideModule
	],
	providers: [
		{ provide: '$scope', useExisting: '$rootScope' },
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				...new MatDialogConfig(),
				maxWidth: ''
			}
		},
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: { appearance: 'outline' }
		},
		provideHttpClient(withInterceptorsFromDi())
	]
})
export class AppModule implements DoBootstrap {
	constructor (
		private upgrade: UpgradeModule,
		private appDataService: AppDataService
	) {}

	public ngDoBootstrap (app: ApplicationRef): void {
		injectAppData().then((appData) => {
			this.appDataService.setAppData(appData);
			setAngularJSGlobal(angular);
			const injector: ng.auto.IInjectorService = this.upgrade.bootstrap(
				document.body,
				[ltiLegacyModule]
			);
			const localizeHelper: GoLocalizeHelperService =
				injector.get('goLocalizeHelper');
			localizeHelper
				.configure(Language.EN)
				.then(() => app.bootstrap(AppComponent));
		});
	}
}
